module.exports = __webpack_public_path__ + "media/images/career_camp/2023/areas_4-152e92bacf45307dc14683b59c6586a3.png";